import React from "react";

/**
 * Icons — shared inline SVG icon set for the Attendance & Leave module.
 * No icon fonts, no emoji. Every icon is a small, crisp, stroke-based SVG
 * that inherits `currentColor`, so it tints automatically with text color.
 *
 * Usage:  import Icons from "./Icons";  ... {Icons.clock}
 */
const svg = (paths) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {paths}
  </svg>
);

const Icons = {
  clock: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></>),
  calendar: svg(<><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M3 9h18M8 2v4M16 2v4" /></>),
  leave: svg(<><path d="M3 21V5a2 2 0 0 1 2-2h9l-2 3 2 3H5" /><path d="M3 21h18" /></>),
  balance: svg(<><path d="M12 2v20M2 9h20" /><circle cx="7" cy="14" r="3" /><circle cx="17" cy="14" r="3" /></>),
  history: svg(<><path d="M3 3v6h6" /><path d="M3.5 9a9 9 0 1 1-1 4" /><path d="M12 8v4l3 2" /></>),
  permission: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" /></>),
  stats: svg(<><path d="M3 3v18h18" /><path d="M7 15l3-4 3 2 4-6" /></>),
  gear: svg(<><circle cx="12" cy="12" r="3" /><path d="M19.4 13a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2 2 2 0 1 1-4 0 1.7 1.7 0 0 0-2.9-1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0-1.2-2.9 2 2 0 1 1 0-4 1.7 1.7 0 0 0 1.2-2.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3H9a1.7 1.7 0 0 0 1-1.5 2 2 0 1 1 4 0 1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9V13z" /></>),
  quota: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 3v9l6 3" /></>),
  report: svg(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M9 13h6M9 17h4" /></>),
  pdf: svg(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M12 12v6M9 15l3 3 3-3" /></>),
  excel: svg(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M9 13l6 6M15 13l-6 6" /></>),
  present: svg(<path d="M20 6L9 17l-5-5" />),
  late: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  absent: svg(<><circle cx="12" cy="12" r="9" /><path d="M15 9l-6 6M9 9l6 6" /></>),
  team: svg(<><circle cx="9" cy="8" r="3" /><path d="M3 20a6 6 0 0 1 12 0" /><path d="M16 6a3 3 0 0 1 0 6M21 20a6 6 0 0 0-4-5.6" /></>),
  search: svg(<><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>),
  close: svg(<path d="M6 6l12 12M18 6L6 18" />),
  check: svg(<path d="M20 6L9 17l-5-5" />),
  chevronLeft: svg(<path d="M15 6l-6 6 6 6" />),
  chevronRight: svg(<path d="M9 6l6 6-6 6" />),
  download: svg(<><path d="M12 3v12M8 11l4 4 4-4" /><path d="M4 21h16" /></>),
  filter: svg(<path d="M4 4h16l-6 8v6l-4 2v-8z" />),
};

export default Icons;
